// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d609d7f3","455":"0be9ba9b","977":"4faf90ff"}[chunkId] + ".chunk.js";
};